import { Component, ErrorInfo, ReactNode, useRef } from "react";
import store from "../../redux/store";
import { logException } from "../../utils/sentry";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    store.dispatch(logException(error));
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}

export default ErrorBoundary;
